module.exports = __webpack_public_path__ + "img/22.92895177.png";